import React, { useEffect, useState } from 'react';

export const AppContext = React.createContext([{}, () => {}]);

export const AppProvider = (props) => {
  const [cart, setCart] = useState(null);

  useEffect(() => {
    if (process.browser) {
      let cartData = localStorage.getItem('woo-next-cart');
      cartData = null !== cartData ? JSON.parse(cartData) : '';
      setCart(cartData);
    }
  }, []);

  return (
    <AppContext.Provider value={[cart, setCart]}>
      {props.children}
    </AppContext.Provider>
  );
};

function DeployRefreshManager() {
  setInterval(async () => {
    const { buildId } = await (await fetch('/api/build-id')).json();
    if (buildId && process.env.BUILD_ID && buildId !== process.env.BUILD_ID) {
      window.location.reload();
    }
  }, 3600000);

  return null;
}
